import React from 'react';
import CanvasJSReact from '../../canvasjs/canvasjs.react';

var CanvasJS = CanvasJSReact.CanvasJS;
var CanvasJSChart = CanvasJSReact.CanvasJSChart;

export function GenericGraph(props){
		
	return (
		<div>
			<CanvasJSChart options = {props.options}/>
		</div>
	);
	
}